import React from 'react';
import { Player } from '../../domain/entities';
import { Modal } from './Modal';
import './SkillDetailModal.css';

interface SkillDetailModalProps {
    player: Player;
    isOpen: boolean;
    onClose: () => void;
}

export const SkillDetailModal: React.FC<SkillDetailModalProps> = ({ player, isOpen, onClose }) => {
    const formClass = player.form > 0 ? 'positive' : player.form < 0 ? 'negative' : 'text-secondary';
    
    // These calculations are illustrative and match the logic in the match simulator
    const fitnessModifier = 0.5 + (player.fitness / 200); // Range: 0.5 to 1.0
    const injuryModifier = player.injury?.type === 'Light' ? 0.8 : 1.0;
    const matchPerformanceSkill = (player.skill + player.form) * fitnessModifier * injuryModifier;

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <h2>Effective Skill Breakdown</h2>
            <div className="skill-detail-modal-content">
                <p><strong>Effective Skill</strong> is a quick measure of a player's current ability, combining their base skill with their current form.</p>
                <ul className="skill-breakdown-list">
                    <li>
                        <span>Base Skill</span>
                        <span>{player.skill}</span>
                    </li>
                    <li>
                        <span>Form Modifier</span>
                        <span className={formClass}>{player.form > 0 ? '+' : ''}{player.form}</span>
                    </li>
                    <li className="total">
                        <span>Effective Skill</span>
                        <span>{player.skill + player.form}</span>
                    </li>
                </ul>
                
                <h3>Match Performance Modifiers</h3>
                <p>In an actual match, a player's performance is further modified by their fitness and injury status.</p>
                <ul className="skill-breakdown-list">
                    <li>
                        <span>Effective Skill</span>
                        <span>{player.skill + player.form}</span>
                    </li>
                     <li>
                        <span>Fitness ({player.fitness}%)</span>
                        <span>x{fitnessModifier.toFixed(2)}</span>
                    </li>
                     <li>
                        <span>Injury</span>
                        <span>x{injuryModifier.toFixed(2)}</span>
                    </li>
                    <li className="total">
                        <span>Expected Match Performance</span>
                        <span>~{Math.round(matchPerformanceSkill)}</span>
                    </li>
                </ul>

            </div>
            <div className="modal-actions">
                <button className="button" onClick={onClose}>Close</button>
            </div>
        </Modal>
    );
};
